export function heatmapBarsAnimation() {
  const container = document.querySelector(
    "#tenesys-block-heatmap-bars-animation",
  );
  if (!container) return;
  const heatmapAnimation = (p) => {
    let W = 750;
    let H = 340;

    let COLS = 10;
    let TILE_W = Math.floor(W / COLS);
    let TILE_H = 10;
    let ROWS = Math.floor(H / TILE_H);
    let X_OFFSET = (W - COLS * TILE_W) / 2;

    let PALETTE = ["#003CFF", "#184EFF", "#416DFF", "#8CA7FF", "#D4DEFF"];
    let K = PALETTE.length;

    let currIdx, nextIdx;
    let tFade, dur;
    let colHeight;

    p.setup = function () {
      const canvas = p.createCanvas(W, H);
      canvas.parent(
        container.querySelector(".kt-inside-inner-col") || container,
      );

      p.frameRate(60);
      p.noStroke();

      initFadeStates();
      initColumns();
    };

    function initFadeStates() {
      currIdx = [];
      nextIdx = [];
      tFade = [];
      dur = [];

      for (let cx = 0; cx < COLS; cx++) {
        currIdx[cx] = [];
        nextIdx[cx] = [];
        tFade[cx] = [];
        dur[cx] = [];

        for (let ry = 0; ry < ROWS; ry++) {
          currIdx[cx][ry] = p.floor(p.random(K));
          nextIdx[cx][ry] = pickNeighbor(currIdx[cx][ry]);
          tFade[cx][ry] = p.random(1.0);
          dur[cx][ry] = p.random(0.8, 2.2);
        }
      }
    }

    function initColumns() {
      colHeight = [];
      for (let cx = 0; cx < COLS; cx++) {
        colHeight[cx] = p.floor(p.random(4, ROWS + 1));
      }
    }

    function pickNeighbor(idx) {
      if (idx === 0) return 1;
      if (idx === K - 1) return K - 2;
      return idx + (p.random() < 0.5 ? -1 : 1);
    }

    function easeInOutSine(u) {
      return 0.5 - 0.5 * Math.cos(u * p.TWO_PI);
    }

    p.draw = function () {
      p.background("#FFFFFF");
      let dt = 1.0 / 60.0;

      for (let r = 0; r < ROWS; r++) {
        let yPix = H - (r + 1) * TILE_H;

        for (let cx = 0; cx < COLS; cx++) {
          if (r >= colHeight[cx]) continue;

          let xPix = X_OFFSET + cx * TILE_W;

          tFade[cx][r] += dt / dur[cx][r];
          if (tFade[cx][r] >= 1.0) {
            currIdx[cx][r] = nextIdx[cx][r];
            nextIdx[cx][r] = pickNeighbor(currIdx[cx][r]);
            tFade[cx][r] = 0.0;
            dur[cx][r] = p.random(0.8, 2.2);
          }

          let u = p.constrain(tFade[cx][r], 0, 1);
          let eased = easeInOutSine(u);

          let c1 = p.color(PALETTE[currIdx[cx][r]]);
          let c2 = p.color(PALETTE[nextIdx[cx][r]]);
          let c = p.lerpColor(c1, c2, eased);

          p.fill(c);
          p.rect(xPix, yPix, TILE_W, TILE_H);
        }
      }
    };
  };

  new p5(heatmapAnimation);
}
